import * as React from 'react';
import { BrPage } from '@bloomreach/react-sdk';
import { DataLayer, WebPage } from '@grandvisionhq/analytics';
import { monetate } from '@grandvisionhq/svc-monetate';
import { mapMonetatePageType } from '../utils/map-monetate-page-type.js';
import { useBloomreach } from '../context/context.js';

const CmsContainerPage = ({ children  })=>{
    const { componentDefinitions ={} , pageModel , sdkConfig , pageSeo  } = useBloomreach();
    React.useEffect(()=>{
        var ref;
        const pageName = (ref = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page.name) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        const seoPageType = pageSeo === null || pageSeo === void 0 ? void 0 : pageSeo.type;
        DataLayer.pushPageTypeToDataLayer(seoPageType, pageName);
        if (seoPageType && !(pageName === null || pageName === void 0 ? void 0 : pageName.includes('checkout')) && !(pageName === null || pageName === void 0 ? void 0 : pageName.includes('product-detail-page'))) {
            const monetatePageName = mapMonetatePageType(seoPageType);
            // These pages contain other monetate API calls which need to be called simultaneously, so the pages will commit the event themselves
            if (monetatePageName !== 'category' && monetatePageName !== 'product' && monetatePageName !== 'cart') {
                monetate().commitMonetateEvent(monetatePageName);
            }
        }
    }, []);
    if (!sdkConfig) {
        console.warn(`Tried to render CmsContainerPage without a valid Bloomreach SDK configuration: ${String(sdkConfig)}`);
        return null;
    }
    if (!pageModel) {
        console.warn(`Tried to render CmsContainerPage without a valid Bloomreach PageModel: ${String(pageModel)}`);
        return null;
    }
    return /*#__PURE__*/ React.createElement(BrPage, {
        configuration: sdkConfig,
        mapping: componentDefinitions,
        page: pageModel
    }, children, pageSeo && /*#__PURE__*/ React.createElement(WebPage, {
        pageType: pageSeo.type,
        url: pageSeo.canonicalUrl,
        name: pageSeo.title,
        description: pageSeo.description
    }));
};
var CmsContainerPage$1 = CmsContainerPage;

export { CmsContainerPage, CmsContainerPage$1 as default };
//# sourceMappingURL=container.js.map
